// ** React Imports
import { createContext, useEffect, useState } from "react";

// ** Next Import
import { useRouter } from "next/router";

// ** Axios
import axios from "src/configs/axios";

// ** Config
import authConfig from "src/configs/auth";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import CartServices from "src/services/cart";
import { queryClient } from "src/configs/reactQuery";

// ** Defaults
const defaultProvider = {
  userData: { token: null },
  loading: true,
  setUser: () => null,
  setLoading: () => Boolean,
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
};
const AuthContext = createContext(defaultProvider);

const AuthProvider = ({ children }) => {
  // ** States
  const [user, setUser] = useState({ token: null, userData: {} });
  const [loading, setLoading] = useState(defaultProvider.loading);
  const queryClient = useQueryClient();

  // ** Hooks
  const router = useRouter();

  useEffect(() => {
    const isLogin = window.localStorage.getItem(authConfig.storageTokenKeyName);
    if (isLogin) {
      axios.defaults.headers.common["authorization"] = `Bearer ${isLogin}`;
      queryClient.fetchQuery({
        queryKey: ["cart"],
        queryFn: CartServices.fetchCart,
      });
    }
    setUser({
      token: window.localStorage.getItem(authConfig.storageTokenKeyName),
      userData: JSON.parse(window.localStorage.getItem("userData")),
    });
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogin = (userData, token) => {
    axios.defaults.headers.common["authorization"] = `Bearer ${token}`;

    const returnUrl = router.query.returnUrl;
    setUser({ userData: userData, token: token });
    window.localStorage.setItem("userData", JSON.stringify(userData));
    window.localStorage.setItem(authConfig.storageTokenKeyName, token);
    const redirectURL = returnUrl && returnUrl !== "/" ? returnUrl : "/";
    router.replace(
      router.query?.redirect
        ? `${router.query?.redirect}?url=${router.query?.url}`
        : redirectURL
    );
  };

  const handleLogout = (redirect) => {
    // console.log('logouuuuuut')
    window.localStorage.removeItem("userData");
    window.localStorage.removeItem(authConfig.storageTokenKeyName);
    setUser({ userData: {}, token: null });
    // queryClient.removeQueries()
    redirect && router.push("/login");
  };

  const handleRegister = (token) => {
    axios.defaults.headers.common["authorization"] = `Bearer ${token}`;
  };

  const values = {
    userData: user,
    loading,
    isLogin: user.token !== null,
    setUser,
    setLoading,
    login: handleLogin,
    logout: handleLogout,
    register: handleRegister,
  };

  return (
    <AuthContext.Provider
      value={{
        ...values,
        userData: user,
        loading,
        isLogin: user.token !== null,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
